module.exports = __webpack_public_path__ + "static/img/16.76151e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/sp/16.png
// module id = kBdw
// module chunks = 0